export default {
  L_APPLICATION_MANAGE_TITLE: "Quản lý ứng dụng",

  OBJ_APPLICATION_TABLE_COL: {
    applicationID: "ID",
    applicationName: "Tên ứng dụng",
    applicationHost: "Địa chỉ ứng dụng",
    sourceId: "Nguồn",
  },
};
